import Vue from 'vue'
import pageLoading from './index.vue'

let MessageConstructor = Vue.extend(pageLoading)

let instance
const MessageTip = {
    open(options={}){
        instance = new MessageConstructor({
            data: {...options, isShow: true}
        })
        document.body.appendChild(instance.$mount().$el) //this.$el拿到组件实际上的dom，把他挂载到body上
        if(options.duration){
            setTimeout(()=>{
                this.close()
            }, options.duration)
        }
    },
    close(){
        if(instance){
            instance.isShow = false;
            instance.$nextTick(()=>document.body.removeChild(instance.$mount().$el))
        }
        
        
    }
};



// function(options = {}) {
//     instance = new MessageConstructor({
//         data: options
//     })
//     document.body.appendChild(instance.$mount().$el) //this.$el拿到组件实际上的dom，把他挂载到body上
//     if(options.duration){
//         setTimeout(()=>{
//             instance.isShow = false;
//         }, params.duration)
//     }
//     // setTimeout(() => {
//     //     document.body.removeChild(instance.$mount().$el) 
//     // }, 3000);  //3秒之后自动移除dom组件

// }

export default MessageTip